import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    Delete,
    updateProduct,
} from "../../Redux/Slices/Products/productsAction";

function Products({
    id,
    name,
    image,
    disponible,
    subCategory,
    description,
    price,
}) {
    const dispatch = useDispatch();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
        if (storedIsLoggedIn === "true") {
            setIsLoggedIn(true);
        }
    }, []);

    const handleDelete = (id) => {
        dispatch(Delete(id));
        console.log(id);
        window.alert("Producto eliminado");
        window.location.reload();
    };
    const handleEdit = () => {
        const productData = {
            id,
            name,
            image,
            disponible,
            subCategory,
            description,
            price,
        };
        dispatch(updateProduct(productData));
        window.location.replace(`/products/${id}`);
    };

    return (
        <div class="bg-gray-300 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 mb-10 p-4 h-full">
            <div class="shadow-md rounded-lg min-w-xs max-w-xs max-h-xs min-h-xs bg-slate-700 flex flex-col">
                <h3 class="text-white font-semibold text-lg tracking-tight truncate dark:text-white text-center">
                    {name}
                </h3>

                <img
                    class="rounded-t-lg p-8 ml-2 w-full h-64 object-cover"
                    src={image}
                />
                <div class="px-5 pb-5 mt-1 max-h-48 overflow-y-auto">
                    <p class=" text-white text-ellipsis tracking-tight dark:text-white">
                        {description.length > 100
                            ? description.slice(0, 100) + "..."
                            : description}
                    </p>

                    <div class="flex items-center mt-2.5 mb-5"></div>
                    <div class="flex items-center justify-between">
                        <ul>
                            <li>
                                <span class="text-1xl font-bold text-red-500">
                                    ${price}
                                </span>
                            </li>
                            <li>
                                <span class="text-1xl font-bold text-red-500">
                                    {disponible}
                                </span>
                            </li>
                        </ul>
                        <a
                            href="https://wa.me/573202951380"
                            class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-red-400 dark:focus:ring-blue-800"
                        >
                            Consultenos!
                        </a>
                        {typeof isLoggedIn === "boolean" && isLoggedIn ? (
                            <button onClick={() => handleDelete(id)}>❌</button>
                        ) : null}
                        {typeof isLoggedIn === "boolean" && isLoggedIn ? (
                            <button onClick={() => handleEdit(id)}>🖊️</button>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Products;
